import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    // height: '100vh',
    '& .btn-filter': {
      textTransform: 'none',
      borderRadius: 8,
      padding: '4px 12px',
      color: '#282828',
      border: `1px solid ${Colors.greyDark} !important`,
    },
    '& .notif-card': {
      padding: 8,
      marginBottom: 8,
      borderRadius: 8,
      background: 'linear-gradient(270deg, #FFEDFF 0%, #FFF1F1 100%)',
    },
  },
};

export default styles;
